import { DeepPartial, FieldValues } from 'react-hook-form'
import { isEqual } from 'lodash-es'

/**
 * Checks if the form values are unchanged from defaults.
 * Sorts tokensGatedBy arrays before comparing to handle order differences.
 */
export function checkIsUnchanged<T extends FieldValues>(
    defaultValues: Readonly<DeepPartial<T>> | undefined,
    currentValues: T,
): boolean {
    const def = structuredClone(defaultValues)
    const cur = structuredClone(currentValues)

    // Sort tokensGatedBy arrays to handle order differences
    if (Array.isArray(def?.tokensGatedBy)) {
        def.tokensGatedBy.sort()
    }
    if (Array.isArray(cur?.tokensGatedBy)) {
        cur.tokensGatedBy.sort()
    }

    return isEqual(def, cur)
}

/**
 * Determines if the submit button should be disabled.
 */
export function checkIsDisabled({
    isSubmitting,
    isUnchanged,
    hasErrors,
    gatingType,
    tokensGatedBy,
    usersGatedBy,
    ethBalanceGatedBy,
    isLoadingPricingModules,
    isLoadingRoleDetails,
    transactionIsPending,
}: {
    isSubmitting: boolean
    isUnchanged: boolean
    hasErrors: boolean
    gatingType: 'everyone' | 'gated'
    tokensGatedBy: unknown[]
    usersGatedBy: unknown[]
    ethBalanceGatedBy: string | null
    isLoadingPricingModules: boolean
    isLoadingRoleDetails: boolean
    transactionIsPending: boolean
}): boolean {
    const isGatedWithNoEntitlements =
        gatingType === 'gated' &&
        tokensGatedBy.length === 0 &&
        usersGatedBy.length === 0 &&
        !ethBalanceGatedBy

    return (
        isSubmitting ||
        isUnchanged ||
        hasErrors ||
        isGatedWithNoEntitlements ||
        isLoadingPricingModules ||
        isLoadingRoleDetails ||
        transactionIsPending
    )
}
